module.exports = __webpack_public_path__ + "static/img/alipay.8eec12b7.png";